import { ApiError } from './api';
import { EN, type StringKey } from './strings';
import type { T } from './i18n';

/**
 * Plain words for any failure — never the server's raw message. Known API codes (docs/API.md §11) have their own
 * line (`err.<CODE>` in strings.ts); otherwise no connection / our side / too many tries / generic.
 */
export function errorKey(e: unknown): StringKey {
  if (e instanceof ApiError) {
    const k = `err.${e.code}` as StringKey;
    if (k in EN) return k;
    if (e.status === 0) return 'err.network';
    if (e.status === 429) return 'err.busy';
    if (e.status >= 500) return 'err.server';
  }
  if (e instanceof TypeError) return 'err.network';
  return 'err.generic';
}

/** The launch allow-list's own words explain the small test group, so that one is shown as the server says it. */
const SERVER_WORDS = new Set(['SIGNIN_NOT_ALLOWED']);
export const friendly = (e: unknown, t: T) => (e instanceof ApiError && SERVER_WORDS.has(e.code) && e.message ? e.message : t(errorKey(e)));
export const codeOf = (e: unknown) => (e instanceof ApiError ? e.code : null);
